import React from 'react';
import { NavLink } from 'react-router-dom';

export function Error404() {
    
    return (
        <div className='items-center justify-center flex h-screen'>
            <div className='justify-start gap-10 flex flex-col'>
                <h1 className='text-6xl font-bold'>404 Error: Sorry we cannot find this page</h1>
                <div className='flex flex-row gap-4'>
                    <h1 className='text-4xl font-bold'>Return Home here</h1>
                    <NavLink className='button1 hover:bg-gray-400' to={'/'}> Home </NavLink>
                </div>
            </div>
        </div>
    );
}